import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import _ from 'lodash';

@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.scss'],
})
export class EmailTemplateComponent extends BaseCtl {
  applicationId: number = 0; // store app id as number

  showTemplateForm: boolean = false; // flag for Template form

  // define templates as an array for testing
  templates: any[] = [];

  constructor(locator: ServiceLocatorService, route: ActivatedRoute) {
    // pass endpoint + required services to BaseListCtl
    super('endpoint.emailtemplate', locator, route);
    let _self = this;
    _self.applicationId = Number(this.route.snapshot.paramMap.get('appId'));
    // _self.form.searchParams['appId'] = _self.applicationId;
    this.getAllTemplate();
  }
  
  saveTemplateConfig() {
    let _self = this;

    _self.form.data['appId'] = _self.applicationId;

    let url =
      _self.locator.config.get('endpoint.emailtemplate') + '/emailtemplatesave';

    console.log('Saving Template Config with payload:', _self.form.data);
    console.log('url : ' + url);

    _self.locator.http.post(
      url,
      _self.form.data,
      function (res: any, error: any) {
        if (error) {
          console.error('Error while saving template config:', error);
          _self.form.error = true;
          _self.form.message = 'Failed to save Email Template!';

          setTimeout(() => {
            _self.closeModal();
            _self.clearMessage(_self.form);
          }, 1500);
          return;
        }

        _self.form.error = !res.success;
        _self.form.message =
          res.message ||
          res.result?.message ||
          (res.success
            ? ' Email Template saved successfully!'
            : ' Failed to save Email Template!');

        if (res.success) {
          console.log('Email Template saved:', res);

          setTimeout(() => {
            _self.getAllTemplate();
            _self.resetForm();
            _self.clearMessage(_self.form);
            _self.closeModal(); 
          }, 1500);
        } else {
          _self.form.inputerror = res.result?.inputerror || {};

          setTimeout(() => {
            _self.closeModal(); 
            _self.clearMessage(_self.form);
          }, 1500);
        }
      },
    );
  }

  // helper method to close bootstrap modal
  closeModal() {
    const modalEl: any = document.getElementById('smtpEmailtemplateModal');
    if (modalEl) {
      modalEl.classList.remove('show');
      modalEl.style.display = 'none';
      document.body.classList.remove('modal-open');
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }
  }

  getAllTemplate() {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.emailtemplate') +
      '/emailtemplatelists/' +
      _self.applicationId; // pass appId from component

    console.log('Fetching all email templates from:', url);

    _self.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        console.error('Error while fetching templates:', error);
        _self.form.error = true;
        _self.form.message = 'Failed to fetch templates!';
        return;
      }

      if (res.success) {
        console.log('Templates fetched:', res.result);
        _self.templates = res.result.data; // store in component variable for UI
      } else {
        _self.form.error = true;
        _self.form.message = 'No templates found!';
      }

      setTimeout(() => {
        _self.clearMessage(_self.form);
      }, 5000);
    });
  }

  // Edit Template
  editTemplate(template: any) {
    // Pre-fill modal form with selected template
    this.form.data = { ...template }; // clone to avoid direct reference

    // Show modal manually
    const modalEl: any = document.getElementById('smtpEmailtemplateModal');
    if (modalEl) {
      modalEl.classList.add('show');
      modalEl.style.display = 'block';
      document.body.classList.add('modal-open');

      // Create backdrop if missing
      let backdrop = document.querySelector('.modal-backdrop');
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
      }
    }
  }

  deleteTemplate(id: number) {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.emailtemplate') + '/delete/' + id; // adjust endpoint if different

    console.log('Deleting template with id:', id, 'URL:', url);

    _self.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        console.error('Error deleting template:', error);
        _self.form.error = true;
        _self.form.message = 'Failed to delete template!';
        return;
      }

      if (res.success) {
        console.log('Template deleted successfully:', res);
        _self.getAllTemplate(); // refresh list after delete
      } else {
        console.error('Delete failed:', res);
        _self.form.error = true;
        _self.form.message = res.message || 'Failed to delete template!';
      }

      setTimeout(() => {
        _self.clearMessage(_self.form);
      }, 3000);
    });
  }

  resetsForm() {
    this.form.data = {};
    this.form.error = false;
    this.form.message = '';
    this.form.inputerror = {};
  }
}
